"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDiscountApi = exports.AdminDiscountApiFactory = exports.AdminDiscountApiFp = exports.AdminDiscountApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AdminDiscountApi - axios parameter creator
 * @export
 */
exports.AdminDiscountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Clone discounts from tenant
         * @param {string} [tenantId] tenantId
         * @param {InputCloneDiscountsFromTenant} [inputCloneDiscountsFromTenant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneDiscountsFromTenant: (tenantId, inputCloneDiscountsFromTenant, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/discount/clone/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputCloneDiscountsFromTenant, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create discount
         * @param {string} [tenantId] tenantId
         * @param {EditCreateDiscount} [editCreateDiscount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount: (tenantId, editCreateDiscount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/discount/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editCreateDiscount, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete discount
         * @param {string} discountId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiscount: (discountId, tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'discountId' is not null or undefined
            common_1.assertParamExists('deleteDiscount', 'discountId', discountId);
            const localVarPath = `/admin/discount/{discountId}/`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Edit discount
         * @param {string} discountId
         * @param {EditCreateDiscount} editCreateDiscount
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDiscount: (discountId, editCreateDiscount, tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'discountId' is not null or undefined
            common_1.assertParamExists('editDiscount', 'discountId', discountId);
            // verify required parameter 'editCreateDiscount' is not null or undefined
            common_1.assertParamExists('editDiscount', 'editCreateDiscount', editCreateDiscount);
            const localVarPath = `/admin/discount/{discountId}/`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(editCreateDiscount, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"update\", \"Discount\"]
         * @summary Edit discount image | Permission required: [\"update\", \"Discount\"]
         * @param {string} discountId
         * @param {any} file
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDiscountImage: (discountId, file, tenantId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'discountId' is not null or undefined
            common_1.assertParamExists('editDiscountImage', 'discountId', discountId);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('editDiscountImage', 'file', file);
            const localVarPath = `/admin/discount/{discountId}/image/`
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"]
         * @summary Get admin discounts | Permission required: [\"readAll\", \"Discount\"]
         * @param {string} [tenantId] tenantId
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDiscounts: (tenantId, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/discount/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            if (tenantId !== undefined && tenantId !== null) {
                localVarHeaderParameter['tenant-id'] = String(tenantId);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminDiscountApi - functional programming interface
 * @export
 */
exports.AdminDiscountApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdminDiscountApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Clone discounts from tenant
         * @param {string} [tenantId] tenantId
         * @param {InputCloneDiscountsFromTenant} [inputCloneDiscountsFromTenant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneDiscountsFromTenant(tenantId, inputCloneDiscountsFromTenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneDiscountsFromTenant(tenantId, inputCloneDiscountsFromTenant, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create discount
         * @param {string} [tenantId] tenantId
         * @param {EditCreateDiscount} [editCreateDiscount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount(tenantId, editCreateDiscount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDiscount(tenantId, editCreateDiscount, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete discount
         * @param {string} discountId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiscount(discountId, tenantId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDiscount(discountId, tenantId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Edit discount
         * @param {string} discountId
         * @param {EditCreateDiscount} editCreateDiscount
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDiscount(discountId, editCreateDiscount, tenantId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editDiscount(discountId, editCreateDiscount, tenantId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"update\", \"Discount\"]
         * @summary Edit discount image | Permission required: [\"update\", \"Discount\"]
         * @param {string} discountId
         * @param {any} file
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDiscountImage(discountId, file, tenantId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.editDiscountImage(discountId, file, tenantId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"]
         * @summary Get admin discounts | Permission required: [\"readAll\", \"Discount\"]
         * @param {string} [tenantId] tenantId
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDiscounts(tenantId, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdminDiscounts(tenantId, filter, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminDiscountApi - factory interface
 * @export
 */
exports.AdminDiscountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdminDiscountApiFp(configuration);
    return {
        /**
         *
         * @summary Clone discounts from tenant
         * @param {string} [tenantId] tenantId
         * @param {InputCloneDiscountsFromTenant} [inputCloneDiscountsFromTenant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneDiscountsFromTenant(tenantId, inputCloneDiscountsFromTenant, options) {
            return localVarFp.cloneDiscountsFromTenant(tenantId, inputCloneDiscountsFromTenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create discount
         * @param {string} [tenantId] tenantId
         * @param {EditCreateDiscount} [editCreateDiscount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount(tenantId, editCreateDiscount, options) {
            return localVarFp.createDiscount(tenantId, editCreateDiscount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete discount
         * @param {string} discountId
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiscount(discountId, tenantId, options) {
            return localVarFp.deleteDiscount(discountId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit discount
         * @param {string} discountId
         * @param {EditCreateDiscount} editCreateDiscount
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDiscount(discountId, editCreateDiscount, tenantId, options) {
            return localVarFp.editDiscount(discountId, editCreateDiscount, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Discount\"]
         * @summary Edit discount image | Permission required: [\"update\", \"Discount\"]
         * @param {string} discountId
         * @param {any} file
         * @param {string} [tenantId] tenantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDiscountImage(discountId, file, tenantId, options) {
            return localVarFp.editDiscountImage(discountId, file, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"Discount\"]
         * @summary Get admin discounts | Permission required: [\"readAll\", \"Discount\"]
         * @param {string} [tenantId] tenantId
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDiscounts(tenantId, filter, options) {
            return localVarFp.getAdminDiscounts(tenantId, filter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminDiscountApi - object-oriented interface
 * @export
 * @class AdminDiscountApi
 * @extends {BaseAPI}
 */
class AdminDiscountApi extends base_1.BaseAPI {
    /**
     *
     * @summary Clone discounts from tenant
     * @param {string} [tenantId] tenantId
     * @param {InputCloneDiscountsFromTenant} [inputCloneDiscountsFromTenant]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    cloneDiscountsFromTenant(tenantId, inputCloneDiscountsFromTenant, options) {
        return exports.AdminDiscountApiFp(this.configuration).cloneDiscountsFromTenant(tenantId, inputCloneDiscountsFromTenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create discount
     * @param {string} [tenantId] tenantId
     * @param {EditCreateDiscount} [editCreateDiscount]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    createDiscount(tenantId, editCreateDiscount, options) {
        return exports.AdminDiscountApiFp(this.configuration).createDiscount(tenantId, editCreateDiscount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete discount
     * @param {string} discountId
     * @param {string} [tenantId] tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    deleteDiscount(discountId, tenantId, options) {
        return exports.AdminDiscountApiFp(this.configuration).deleteDiscount(discountId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Edit discount
     * @param {string} discountId
     * @param {EditCreateDiscount} editCreateDiscount
     * @param {string} [tenantId] tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    editDiscount(discountId, editCreateDiscount, tenantId, options) {
        return exports.AdminDiscountApiFp(this.configuration).editDiscount(discountId, editCreateDiscount, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"update\", \"Discount\"]
     * @summary Edit discount image | Permission required: [\"update\", \"Discount\"]
     * @param {string} discountId
     * @param {any} file
     * @param {string} [tenantId] tenantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    editDiscountImage(discountId, file, tenantId, options) {
        return exports.AdminDiscountApiFp(this.configuration).editDiscountImage(discountId, file, tenantId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"readAll\", \"Discount\"]
     * @summary Get admin discounts | Permission required: [\"readAll\", \"Discount\"]
     * @param {string} [tenantId] tenantId
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountApi
     */
    getAdminDiscounts(tenantId, filter, options) {
        return exports.AdminDiscountApiFp(this.configuration).getAdminDiscounts(tenantId, filter, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminDiscountApi = AdminDiscountApi;
